export const getCidFromLocalStorage = () => {
  return sessionStorage.getItem('cid') || '';
};

export const getMailFromLocalStorage = () => {
  return sessionStorage.getItem('mailaddress') || '';
};

export const removeItemLocalStorage = (key: string) => {
  return sessionStorage.removeItem(key);
};

export const getGiftVoucherDetailItemFromLocalStorage = () => {
  let giftVoucherDetailItem = sessionStorage.getItem('gift_voucher_detail_item') || '{}';

  return JSON.parse(giftVoucherDetailItem);
};

export const getIsOnePointFromLocalStorage = () => {
  return sessionStorage.getItem('is_one_point') || 0;
};
